import { Stack, Typography } from '@mui/material';
import { Show } from '@side/pantry';
import Image from 'next/image';
import {
  ErrorPageImages,
  ErrorPageSubtitles,
  ErrorPageTitles,
  type ErrorPageType,
  ShowSideSupportLink,
} from 'src/components/ErrorPage/ErrorPage.constants';
import { SideSupport } from '../SideSupport/SideSupport';

interface Props {
  errorType: ErrorPageType;
  interactionId?: string;
}

export function ErrorPage({ errorType, interactionId }: Props) {
  return (
    <Stack
      sx={{
        mt: 16,
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1.5,
        textAlign: 'center',
      }}
    >
      {!!ErrorPageImages[errorType] && (
        <Image
          alt={ErrorPageTitles[errorType] ?? 'No Results'}
          src={ErrorPageImages[errorType]}
          style={{ marginBottom: 24 }}
        />
      )}

      <Typography variant="h3" component="span">
        {ErrorPageTitles[errorType]}
      </Typography>

      <Typography
        variant="subtitle1"
        data-testid="error-subtitle"
        sx={{ maxWidth: '32rem', color: 'text.secondary' }}
      >
        <Show when={ErrorPageSubtitles[errorType]}>
          {ErrorPageSubtitles[errorType]}
        </Show>

        <Show when={ShowSideSupportLink[errorType]}>
          <span>
            &nbsp;If you believe this is an error, please contact&nbsp;
            <SideSupport interactionId={interactionId} />
            &nbsp;for assistance.
          </span>
        </Show>
      </Typography>
    </Stack>
  );
}
